export default "__VITE_ASSET__BEvYX7ub__"